import React from 'react';

const PhoneLink = ({ phone }) => React.createElement(
  'a',
  {
    className: 'position-relative  ml-3 font-xl',
    href: `tel:${phone}`,
  },
  React.createElement('i', {
    className: 'icon icon-phone position-absolute',
    title: 'phone',
    style: { bottom: '0px' },
  }),
);

export default PhoneLink;
